import type { SnackbarCloseReason } from '@mui/material/Snackbar';
import { type SyntheticEvent, useEffect, useState } from 'react';

export const useSnackbarState = (value: unknown, clearValue: () => void) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (value) {
      setOpen(true);
    }
  }, [value]);

  const onClose = (
    _event: SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason !== 'clickaway') {
      setOpen(false);
    }
  };

  return {
    open,
    onClose,
    slotProps: { transition: { onExited: clearValue } },
  };
};
